import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  listMyEventParticipation: (
    page: number,
    cfg?: AxiosConfig,
    filters?: Record<string, unknown>[],
  ) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query (
          $page: Int!
          $filters: [Filter]
        ) {
          listMyEventParticipation (
            page: $page
            limit: 10
            filters: $filters
            sorters: [{ name: "creationTime" order: DESC }]
          ) {
            items {
              id
              creationTime
              state
              event {
                alias
                title {
                  current
                }
                region {
                  title {
                    current
                  }
                }
                allowedCategories
                features
                start
                finish
                participating
                contest {
                  start
                  finish
                }
                minBirthdate
                maxBirthdate
                registrationFinish
              }
              status {
                alias
                title {
                  current
                }
                workflow
              }
            }
            pagination {
              pages
            }
          }
        }
      `,

      variables: {
        page,
        filters,
      },
    }, cfg),
  ),

  revokeParticipation: (id: string, reason: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation ($id: UUID! $reason: String!) {
          revokeEventParticipation(participation: $id reason: $reason)
        }
      `,

      variables: {
        id,
        reason,
      },
    }),
  ),

  confirmEventParticipation: (id: string, reserve = false) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation ($id: UUID! $reserve: Boolean) {
          confirmEventParticipation(participation: $id reserve: $reserve)
        }
      `,

      variables: {
        id,
        reserve,
      },
    }),
  ),

  listMyEventParticipationDrafts: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listMyEventParticipation (
            filters: [{ name: "state" value: "draft" }]
            limit: 999
          ) {
            items {
              state
            }
          }
        }
      `,
    }),
  ),

  listMyEventParticipationForDetails: (
    filters: any[], cfg?: AxiosConfig,
  ) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query(
          $filters: [Filter]
        ) {
          listMyEventParticipation (
            limit: 1
            filters: $filters
            sorters: [{ name: "creationTime" order: DESC }]
          ) {
            items {
              id
              state
              creationTime
              birthdate
              user {
                id
              }
              event {
                alias
                features
                start
                finish
                contest {
                  finish
                }
              }
              residence {
                id
              }
              citizenship {
                id
              }
              ticket {
                id
                state
                firstName {
                  current
                }
                lastName {
                  current
                }
                patronymic {
                  current
                }
                departureCountry {
                  id
                  title { current }
                }
                departureCity {
                  id
                  title { current }
                }
                departureDate
                departureTime
                departurePoint
                arrivalDate
                arrivalTime
                arrivalPoint
                arrivalPointNew {
                  id
                  title { current }
                }
                arrivalOnMyOwn
                arrivalVehicleNumber
                arrivalTicket {
                  path
                  url
                }
                returnDate
                returnTime
                returnPoint
                returnPointNew {
                  id
                  title { current }
                }
                returnOnMyOwn
                returnVehicleNumber
                returnTicket {
                  path
                  url
                }
                reviewState
              }
              attributes
              regionalProgramApplication {
                id
                state
                ticketState
                ticketReviewState
                ticket {
                  url
                }
                region {
                  description {
                    current
                  }
                }
              }
              recommendations {
                approvedByDirection
                recommendedByPartnerDkk
                artMastersInvitation
                functionalDirection
              }
              roomReservation {
                id
                room {
                  hotel {
                    title {
                      current
                    }
                    address {
                      current
                    }
                    phone {
                      current
                    }
                    website {
                      current
                    }
                    checkInTime
                    checkOutTime
                  }
                }
                checkInDate
                checkOutDate
              }
              foodStreams {
                stream {
                  id
                  foodPlace {
                    title {
                      current
                    }
                    address {
                      current
                    }
                  }
                  mealType
                  date
                  startTime
                  finishTime
                }
              }
              pcrCheck {
                id
                state
                place {
                  id
                  place {
                    current
                  }
                  address {
                    current
                  }
                  startDate
                  startTime
                  finishDate
                  finishTime
                }
              }
              status {
                alias
              }
            }
          }
        }
      `,

      variables: {
        filters,
      },
    }, cfg),
  ),

  updateTravelTicketArrivalDetails: (variables: Record<string, any>) =>
    wrapGql(
      a.$post("/graphql", {
        query: /* gql */ `
        mutation (
          $ticket: UUID!
          $arrivalDate: String!
          $arrivalTime: String!
          $arrivalPointNew: UUID
          $arrivalOnMyOwn: Boolean
          $arrivalVehicleNumber: String
          $arrivalTicket: UploadPath
          $departureCountry: UUID
          $departureCity: UUID
          $departureDate: String
          $departureTime: String
          $departurePoint: String
        ) {
          updateTravelTicketArrivalDetails (
            ticket: $ticket
            arrivalDate: $arrivalDate
            arrivalTime: $arrivalTime
            arrivalPointNew: $arrivalPointNew
            arrivalOnMyOwn: $arrivalOnMyOwn
            arrivalVehicleNumber: $arrivalVehicleNumber
            arrivalTicket: $arrivalTicket
            departureCountry: $departureCountry
            departureCity: $departureCity
            departureDate: $departureDate
            departureTime: $departureTime
            departurePoint: $departurePoint
          )
        }
      `,

        variables,
      }),
    ),

  updateTravelTicketReturnDetails: (variables: Record<string, any>) =>
    wrapGql(
      a.$post("/graphql", {
        query: /* gql */ `
        mutation (
          $ticket: UUID!
          $returnDate: String!
          $returnTime: String!
          $returnPointNew: UUID
          $returnOnMyOwn: Boolean
          $returnVehicleNumber: String
          $returnTicket: UploadPath
        ) {
          updateTravelTicketReturnDetails (
            ticket: $ticket
            returnDate: $returnDate
            returnTime: $returnTime
            returnPointNew: $returnPointNew
            returnOnMyOwn: $returnOnMyOwn
            returnVehicleNumber: $returnVehicleNumber
            returnTicket: $returnTicket
          )
        }
      `,

        variables,
      }),
    ),

  listTravelTicketDestination: (filters?: Record<string, any>) =>
    wrapGql(
      a.$post("/graphql", {
        query: /* gql */ `
          query ($filters: [Filter]) {
            listTravelTicketDestination (limit: 999 filters: $filters) {
              items {
                id
                title { current }
                arrivalPoint
                returnPoint
                optionalTicket
              }
            }
          }
        `,
        variables: { filters },
      }),
      "listTravelTicketDestination",
    ),

  updateTravelTicketUserComment: (variables: Record<string, any>) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $ticket: UUID
          $userComment: String
        ) {
          updateTravelTicketUserComment (
            ticket: $ticket
            userComment: $userComment
          )
        }
      `,

      variables,
    }),
  ),

  listEventParticipation: ({
    page,
    filters,
    sorters,
  }: {
    page: number
    filters?: any[]
    sorters?: any[]
  }) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query (
          $page: Int!
          $filters: [Filter]
          $sorters: [Sorter]
        ) {
          listEventParticipation (
            page: $page
            filters: $filters
            sorters: $sorters
          ) {
            items {
              id
              creationTime
              state
              phone
              firstName {
                current
              }
              lastName {
                current
              }
              patronymic {
                current
              }
              citizenship {
                id
                title {
                  current
                }
              }
              residence {
                id
              }
              user {
                id
                email
              }
              attributes
              applications {
                state
                stage {
                  title {
                    current
                  }
                }
              }
            }
            pagination {
              pages
            }
          }
        }
      `,

      variables: {
        page,
        filters,
        sorters,
      },
    }),
  ),

  approveTravelTicket: (ticket: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $ticket: UUID
        ) {
          approveTravelTicket (
            ticket: $ticket
          )
        }
      `,

      variables: {
        ticket,
      },
    }),
  ),

  updateTravelTicketPersonalDetails: (variables: Record<string, any>) =>
    wrapGql(
      a.$post("/graphql", {
        query: /* gql */ `
          mutation (
            $ticket: UUID
            $departureCountry: UUID
            $departureCity: UUID
            $secondDocument: Boolean
            $isVisaRequired: Boolean
            $visaCountry: UUID
            $visaCity: UUID
            $needsTransferInVisaCity: Boolean
            $readyToAccompany: Boolean
            $accompanyingPeople: [UUID!]
            $haveEscort: String
            $accompanyingPerson: UUID
            $userComment: String
          ) {
            updateTravelTicketPersonalDetails (
              ticket: $ticket
              departureCountry: $departureCountry
              departureCity: $departureCity
              secondDocument: $secondDocument
              isVisaRequired: $isVisaRequired
              visaCountry: $visaCountry
              visaCity: $visaCity
              needsTransferInVisaCity: $needsTransferInVisaCity
              readyToAccompany: $readyToAccompany
              accompanyingPeople: $accompanyingPeople
              haveEscort: $haveEscort
              accompanyingPerson: $accompanyingPerson
              userComment: $userComment
            )
          }
        `,

        variables,
      }),
    ),

  findMyEventParticipationUpdateRequest: (cfg?: AxiosConfig) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          findMyEventParticipationUpdateRequest {
            state
          }
        }
      `,
    }, cfg),
  ),

  confirmRegionalProgramApplication: (application: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation ($application: UUID!) {
          confirmRegionalProgramApplication(application: $application)
        }
      `,

      variables: {
        application,
      },
    }),
  ),

  rejectRegionalProgramApplication: (application: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation ($application: UUID!) {
          rejectRegionalProgramApplication(application: $application)
        }
      `,

      variables: {
        application,
      },
    }),
  ),

  confirmArtMastersInvitation: (id: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation ($id: UUID!) {
          confirmArtMastersInvitation(id: $id) {
            id
          }
        }
      `,

      variables: {
        id,
      },
    }),
  ),

  rejectArtMastersInvitation: (id: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation ($id: UUID!) {
          rejectArtMastersInvitation(id: $id) {
            id
          }
        }
      `,

      variables: {
        id,
      },
    }),
  ),

  approveRegionalProgramApplicationTicket: (application: string) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation ($application: UUID!) {
          approveRegionalProgramApplicationTicket(application: $application)
        }
      `,

      variables: {
        application,
      },
    }),
  ),

  rejectRegionalProgramApplicationTicket: (
    application: string,
    userComment: string,
  ) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $application: UUID!
          $userComment: String!
        ) {
          rejectRegionalProgramApplicationTicket(
            application: $application
            userComment: $userComment
          )
        }
      `,

      variables: {
        application,
        userComment,
      },
    }),
  ),

  findMyFeedback: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          findMyFeedback {
            id
          }
        }
      `,
    }),
  ),

  updateEventParticipationStatusForDobroUser: (
    participation: string,
    status: string,
    cfg?: AxiosConfig,
  ) => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        mutation (
          $participation: UUID!
          $status: UUID!
        ) {
          updateEventParticipationStatusForDobroUser (
            participation: $participation
            status: $status
          )
        }
      `,

      variables: {
        participation,
        status,
      },
    }, cfg),
  ),
})
